import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  container: {
    margin: theme.customStyles.buttonNavigation.margin
  },
  button: {
    borderRadius: theme.customStyles.buttonNavigation.borderRadius,
    textTransform: theme.customStyles.buttonNavigation.textTransform,
    fontSize: theme.customStyles.buttonNavigation.fontSize,
    padding: theme.customStyles.buttonNavigation.padding
  }
}));

const ButtonNavigation = ({ returnData, setQueryParam }) => {
  const classes = useStyles();

  const handleDataButtonClick = event => {
    const dataButtonId = event.currentTarget.id;
    setQueryParam(dataButtonId);
  };

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      className={classes.container}
    >
      <Grid item xs={4}>
        <Button
          color="primary"
          id="LongShort"
          variant={returnData === 'LongShort' ? 'contained' : 'outlined'}
          onClick={handleDataButtonClick}
          fullWidth
          className={classes.button}
        >
          Long/Short
        </Button>
      </Grid>
      <Grid item xs={4}>
        <Button
          color="primary"
          id="Gross"
          variant={returnData === 'Gross' ? 'contained' : 'outlined'}
          onClick={handleDataButtonClick}
          fullWidth
          className={classes.button}
        >
          Gross
        </Button>
      </Grid>
      <Grid item xs={4}>
        <Button
          color="primary"
          id="Net"
          variant={returnData === 'Net' ? 'contained' : 'outlined'}
          onClick={handleDataButtonClick}
          fullWidth
          className={classes.button}
        >
          Net
        </Button>
      </Grid>
    </Grid>
  );
};

ButtonNavigation.propTypes = {
  returnData: PropTypes.string.isRequired,
  setQueryParam: PropTypes.func.isRequired
};

export default ButtonNavigation;
